
// // import React, { useState, useEffect, useRef } from "react";
// // import Tiffins from "../../../../images/products/all items.jpg";
// // import { Link } from "react-router-dom";
// // // import Offers from "./Offers";
// // import Menuiteams from "./Menuiteams";
// // import { useNavigate } from "react-router-dom";
// // import axios from 'axios';
// // import Foodandbeveragesadvertise from "../../FoodandBeverages/Foodandbeveragesadvertise";
// // import { useLoader } from "../../../../context/LoaderProvider.jsx";
// // import MenuIcon from "@mui/icons-material/Menu";
// // const Menudatas = () => {
// //     const [activeCategory, setActiveCategory] = useState("");
// //     const [parentId, setParentId] = useState(null);
// //     const [isVegSelected, setIsVegSelected] = useState(false);
// //     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
// //     const [items, setItems] = useState([]); // Store API data
// //     const [categories, setCategories] = useState([]);
// //     const [isHovered, setIsHovered] = useState(false);
// //     const [dishes, setDishes] = useState([]);  // Added state for dishes
// //     // const [parentId, setParentId] = useState(null);
// //     const [posts, setPosts] = useState([]);
// //     const { showLoader, hideLoader } = useLoader();
// //     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
// //        // NEW STATE: Control sidebar visibility for menu page
// //     const [isSidebarOpen, setIsSidebarOpen] = useState(true);


// //     const [containerWidth, setContainerWidth] = useState(
// //         window.innerWidth > 1320 ? '160px' : window.innerWidth > 1000 ? '160px' : '150px'
// //     );

// //     useEffect(() => {
// //         const handleResize = () => {
// //             if (window.innerWidth > 1320) {
// //                 setContainerWidth('170px');
// //             } else if (window.innerWidth > 1000) {
// //                 setContainerWidth('150px'); // 👈 smaller width between 1000–1320px
// //             } else {
// //                 setContainerWidth('150px');
// //             }
// //         };

// //         window.addEventListener('resize', handleResize);
// //         return () => window.removeEventListener('resize', handleResize);
// //     }, []);

// //     useEffect(() => {
// //         const handleResize = () => setIsMobile(window.innerWidth <= 768);
// //         window.addEventListener("resize", handleResize);
// //         return () => window.removeEventListener("resize", handleResize);
// //     }, []);
// //     useEffect(() => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId) {
// //             console.warn("⚠️ vendorId not found in localStorage");
// //             return;
// //         }

// //         if (!token) {
// //             console.warn("⚠️ authToken not found in localStorage");
// //             return;
// //         }
// //         showLoader();
// //         fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
// //             headers: {
// //                 'Authorization': `Bearer ${token}`,
// //                 'Content-Type': 'application/json',
// //                 'Accept': 'application/json',
// //             }
// //         })
// //             .then((response) => {
// //                 if (!response.ok) {
// //                     throw new Error(`HTTP error! status: ${response.status}`);
// //                 }
// //                 return response.json();
// //             })
// //             .then((data) => {
// //                 setItems(data); // Set all data without filtering
// //             })
// //             .catch((error) => console.error("Error fetching data:", error)).finally(() => {
// //                 hideLoader();
// //             })
// //     }, []);

// //     useEffect(() => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId) {
// //             console.warn("⚠️ vendorId not found in localStorage");
// //             return;
// //         }

// //         if (!token) {
// //             console.warn("⚠️ authToken not found in localStorage");
// //             return;
// //         }
// //         showLoader();
// //         fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
// //             headers: {
// //                 'Authorization': `Bearer ${token}`,
// //                 'Content-Type': 'application/json',
// //                 'Accept': 'application/json',
// //             }
// //         })
// //             .then((response) => {
// //                 if (!response.ok) {
// //                     throw new Error(`HTTP error! status: ${response.status}`);
// //                 }
// //                 return response.json();
// //             })
// //             .then((data) => {
// //                 // Filter categories where parentId is 0 or null
// //                 const filteredCategories = data.filter((item) => item.parentId === 0 || item.parentId === null);

// //                 // Filter all dishes where parentId is not 0 or null
// //                 const allDishes = data.filter((item) => item.parentId !== 0 && item.parentId !== null);

// //                 // Set the filtered categories and dishes in state
// //                 setCategories(filteredCategories);
// //                 setDishes(allDishes);
// //             })
// //             .catch((error) => console.error("Error fetching data:", error)).finally(() => {
// //                 hideLoader();
// //             })
// //     }, []);




// //     const handleClick = (categoryName) => {
// //         // console.log(`Clicked on category: ${categoryName}`);

// //         if (categoryName === 'Allitems') {
// //             setParentId(null);
// //             setActiveCategory('Allitems');
// //             // console.log('Selected parentId: null (All items selected)');
// //             return;
// //         }

// //         const selectedCategory = categories.find(
// //             category => category.dishName.trim().toLowerCase() === categoryName.trim().toLowerCase()
// //         );

// //         if (selectedCategory) {
// //             // console.log(`Selected parentId: ${selectedCategory.dishId}`);
// //             setParentId(selectedCategory.dishId);
// //             setActiveCategory(categoryName);

// //             // Display matching dishes
// //             const matchingDishes = dishes.filter(
// //                 dish => dish.parentId === selectedCategory.dishId
// //             );
// //             // console.log(`Dishes for parentId ${selectedCategory.dishId}:`, matchingDishes);
// //         } else {
// //             // console.log('Category not found');
// //             setParentId(null);
// //             setActiveCategory('Allitems');
// //         }
// //     };


// //     const navigate = useNavigate();

// //     // Automatically activate the first item from backend data
// //     useEffect(() => {
// //         if (categories.length > 0) {
// //             setActiveCategory("Allitems"); // Default to "Allitems"
// //         }
// //     }, [categories]);



// //     const currentCategoryItems = categories[activeCategory] || [];

// //     const filteredItems = currentCategoryItems.filter((item) => {
// //         if (isVegSelected) return item.type === "Veg";
// //         if (isNonVegSelected) return item.type === "Non-veg";
// //         return true;
// //     });


// //     const scrollContainerRef = useRef(null);




// //     useEffect(() => {
// //         const vendorId = localStorage.getItem("vendorId");

// //         if (!vendorId) {
// //             console.warn("⚠️ vendorId not found in localStorage");
// //             return;
// //         }
// //         showLoader();
// //         axios.get(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`)
// //             .then((response) => {
// //                 const allDishes = response.data;

// //                 // Filter for dishes with the name "Combos"
// //                 const combos = allDishes.filter(dish => dish.dishName === "Combos");

// //                 // Find child dishes with matching parentId
// //                 const filteredData = allDishes.filter(dish =>
// //                     combos.some(combo => combo.dishId === dish.parentId)
// //                 );

// //                 setPosts(filteredData);
// //             })
// //             .catch((error) => {
// //                 // console.error("Error fetching data:", error);
// //             }).finally(() => {
// //                 hideLoader();
// //             })
// //     }, []);





// //     useEffect(() => {
// //         const scrollContainer = scrollContainerRef.current;
// //         if (!scrollContainer) return;

// //         let interval;

// //         const startScrolling = () => {
// //             interval = setInterval(() => {
// //                 if (!isHovered) {
// //                     scrollContainer.scrollTop += 1; // Scroll down smoothly

// //                     // Infinite loop logic
// //                     if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
// //                         scrollContainer.scrollTop = 0; // Reset to top for seamless loop
// //                     }
// //                 }
// //             }, 20); // Adjust speed by changing interval
// //         };

// //         startScrolling();

// //         return () => clearInterval(interval);
// //     }, [isHovered]);


// //     return (
// //         <>
// //             <div className="container-fluid">
// //                 <div className="row " style={{ marginTop: "38px" }}>

// //                     <div className="col-lg-2 col-md-3 col-sm-12 col-12"
// //                     style={{marginTop:window.innerWidth<=767 ? "-30px" : " ",}}>

// //                         <div
// //                             style={{
// //                                 maxHeight: "600px",
// //                                 position: "sticky",
// //                                 top: "0px",
// //                                 marginTop: "67px",
// //                                 zIndex: 1000,
// //                                 // width: "180px",
// //                                 scrollbarWidth: "none",
// //                                 msOverflowStyle: "none",

// //                             }}

// //                             // className="menu-categroy-data"
// //                             className="menu-side-scroll"
// //                         >


// //                             {isMobile ? (
// //                                 <select
// //                                     onChange={(e) => handleClick(e.target.value)}
// //                                     value={activeCategory}
// //                                     style={{
// //                                         width: "100%",
// //                                         padding: "10px",
// //                                         borderRadius: "10px",
// //                                         background: "rgb(177 93 198)",
// //                                         color: "#fff",
// //                                         fontWeight: "bold",
// //                                         border: "1px solid #ccc",
// //                                         marginBottom: "10px",
// //                                         // Make sure the marginLeft isn't causing overflow or the dropdown to be hidden
// //                                         marginLeft: "0px", // Temporarily remove margin for testing
// //                                     }}
// //                                 >
// //                                     <option value="Allitems">All</option>
// //                                     {categories.map((category) => (
// //                                         <option key={category.dishId} value={category.dishName}>
// //                                             {category.dishName}
// //                                         </option>
// //                                     ))}
// //                                 </select>
// //                             ) : (
// //                                 // Card Layout for Desktop View
// //                                 <div
// //                                     style={{
// //                                         overflowY: "auto",
// //                                         height: "550px",
// //                                         marginTop: "96px",
// //                                         scrollbarWidth: "none",
// //                                         width: containerWidth,
// //                                     }}
// //                                 >

// //                                     {/* "Allitems" Category Card */}
// //                                     <div
// //                                         className="card"
// //                                         onClick={() => handleClick("Allitems")}
// //                                         style={{
// //                                             backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
// //                                             marginTop: "4px",
// //                                             padding: "0px",
// //                                             display: "flex",
// //                                             alignItems: "center",
// //                                             flexDirection: "column",
// //                                             cursor: "pointer",
// //                                             zIndex: "1", // Corrected zIndex for proper click behavior
// //                                         }}
// //                                     >
// //                                         <img
// //                                             src={Tiffins}
// //                                             className="card-img-top"
// //                                             alt="Allitems"
// //                                             style={{
// //                                                 borderRadius: "50%",
// //                                                 width: "100px",
// //                                                 height: "100px",
// //                                                 display: "block",
// //                                                 margin: "5px auto 0",
// //                                             }}
// //                                         />
// //                                         <br />
// //                                         <div className="card-body d-flex justify-content-center p-0">
// //                                             <button
// //                                                 style={{
// //                                                     borderRadius: "10px",
// //                                                     marginTop: "-5px",
// //                                                     fontSize: "14px",
// //                                                     padding: "5px 10px",
// //                                                     width: "100px",
// //                                                     marginBottom: "5px",
// //                                                     background: "#fff",
// //                                                     color: "#000",
// //                                                     fontWeight: "bold",
// //                                                     border: "0px",
// //                                                 }}
// //                                             >
// //                                                 All
// //                                             </button>
// //                                         </div>
// //                                     </div>

// //                                     {/* Dynamic Categories from API */}
// //                                     {categories.map((category) => (
// //                                         <div
// //                                             key={category.dishId}
// //                                             className="card"
// //                                             onClick={() => handleClick(category.dishName)}
// //                                             style={{
// //                                                 backgroundColor: activeCategory === category.dishName ? "rgb(177 93 198)" : "#D9D9D9",
// //                                                 marginTop: "10px",
// //                                                 padding: "0px",
// //                                                 display: "flex",
// //                                                 alignItems: "center",
// //                                                 flexDirection: "column",
// //                                                 cursor: "pointer",
// //                                                 height: "165px",
// //                                             }}
// //                                         >
// //                                             <img
// //                                                 className="card-img-top"
// //                                                 src={category.dishImage}
// //                                                 alt={category.dishName}
// //                                                 style={{
// //                                                     borderRadius: "50%",
// //                                                     width: "100px",
// //                                                     height: "98px",
// //                                                     display: "block",
// //                                                     margin: "5px auto 0",
// //                                                     background: "#000",
// //                                                     color: "#fff",
// //                                                 }}
// //                                             />
// //                                             <br />
// //                                             <div className="card-body d-flex justify-content-center p-0">
// //                                                 <button
// //                                                     style={{
// //                                                         borderRadius: "10px",
// //                                                         marginTop: "-5px",
// //                                                         fontSize: "14px",
// //                                                         padding: "5px 10px",
// //                                                         background: "#fff",
// //                                                         color: "#000",
// //                                                         width: "100px",
// //                                                         marginBottom: "5px",
// //                                                         fontWeight: "bold",
// //                                                         border: "0px",
// //                                                     }}
// //                                                 >
// //                                                     {category.dishName}
// //                                                 </button>
// //                                             </div>
// //                                         </div>
// //                                     ))}
// //                                 </div>
// //                             )}

// //                         </div>
// //                     </div>

// //                     <div className="col-lg-7 col-md-7 col-sm-12 col-12" 
// //                     style={{ marginTop:window.innerWidth > 500 && window.innerWidth <= 768 ? "-90px" : "20px",}}>
// //                         <p
// //                             className="breadcrumb maamaas-home-bredcum"
// //                             style={{
// //                                 position: "fixed",
// //                                 top: isMobile ? "50px" : "80px",
// //                                 left: isMobile ? "5px" : "18vw",
// //                                 width: "100%",
// //                                 backgroundColor: "#fff",
// //                                 zIndex: 1000,
// //                                 padding: "10px 0",
// //                                 fontSize: isMobile ? "14px" : "18px",
// //                                 fontWeight: isMobile ? "normal" : "bold",
// //                                 textAlign: "center",
// //                                 margin: 0,


// //                             }}
// //                         >
// //                             {/* <Link
// //                                 to="/Newmainlandingpage"
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Home
// //                             </Link>
// //                             <span className="separator"> &gt; </span> */}
// //                             <Link
// //                                 to="/foodladingpage"
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Food & Beverages
// //                             </Link>
// //                             <span className="separator"> &gt; </span>
// //                             <Link
// //                                 // to="/company"
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Menu_Management
// //                             </Link>
// //                             <span className="separator"> &gt; </span>
// //                             <Link
// //                                 // to="/company"
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Menu
// //                             </Link>


// //                         </p>
// //                         <Menuiteams parentId={parentId} />
// //                     </div>
// //                     <div className="col-lg-3 col-md-3 col-sm-3 col-3">
// //                         <Foodandbeveragesadvertise />
// //                     </div>
// //                 </div>


// //             </div>
// //         </>
// //     );
// // };

// // export default Menudatas;
















// import React, { useState, useEffect, useRef } from "react";
// import Tiffins from "../../../../images/products/all items.jpg";
// import { Link } from "react-router-dom";
// // import Offers from "./Offers";
// import Menuiteams from "./Menuiteams";
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import Foodandbeveragesadvertise from "../../FoodandBeverages/Foodandbeveragesadvertise";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import MenuIcon from "@mui/icons-material/Menu";
// import MenuCartSidebar from "./MenuCartSidebar.jsx";
// const Menudatas = () => {
//     const [activeCategory, setActiveCategory] = useState("");
//     const [parentId, setParentId] = useState(null);
//     const [isVegSelected, setIsVegSelected] = useState(false);
//     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
//     const [items, setItems] = useState([]); // Store API data
//     const [categories, setCategories] = useState([]);
//     const [isHovered, setIsHovered] = useState(false);
//     const [dishes, setDishes] = useState([]);  // Added state for dishes
//     // const [parentId, setParentId] = useState(null);
//     const [posts, setPosts] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//     // NEW STATE: Control sidebar visibility for menu page
//     const [isSidebarOpen, setIsSidebarOpen] = useState(true);


//     const [containerWidth, setContainerWidth] = useState(
//         window.innerWidth > 1320 ? '160px' : window.innerWidth > 1000 ? '160px' : '150px'
//     );

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth > 1320) {
//                 setContainerWidth('170px');
//             } else if (window.innerWidth > 1000) {
//                 setContainerWidth('150px'); // 👈 smaller width between 1000–1320px
//             } else {
//                 setContainerWidth('150px');
//             }
//         };

//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth <= 768);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);
//     useEffect(() => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId) {
//             console.warn("⚠️ vendorId not found in localStorage");
//             return;
//         }

//         if (!token) {
//             console.warn("⚠️ authToken not found in localStorage");
//             return;
//         }
//         showLoader();
//         fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json',
//             }
//         })
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 setItems(data); // Set all data without filtering
//             })
//             .catch((error) => console.error("Error fetching data:", error)).finally(() => {
//                 hideLoader();
//             })
//     }, []);

//     useEffect(() => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId) {
//             console.warn("⚠️ vendorId not found in localStorage");
//             return;
//         }

//         if (!token) {
//             console.warn("⚠️ authToken not found in localStorage");
//             return;
//         }
//         showLoader();
//         fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json',
//             }
//         })
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 // Filter categories where parentId is 0 or null
//                 const filteredCategories = data.filter((item) => item.parentId === 0 || item.parentId === null);

//                 // Filter all dishes where parentId is not 0 or null
//                 const allDishes = data.filter((item) => item.parentId !== 0 && item.parentId !== null);

//                 // Set the filtered categories and dishes in state
//                 setCategories(filteredCategories);
//                 setDishes(allDishes);
//             })
//             .catch((error) => console.error("Error fetching data:", error)).finally(() => {
//                 hideLoader();
//             })
//     }, []);




//     const handleClick = (categoryName) => {
//         // console.log(`Clicked on category: ${categoryName}`);

//         if (categoryName === 'Allitems') {
//             setParentId(null);
//             setActiveCategory('Allitems');
//             // console.log('Selected parentId: null (All items selected)');
//             return;
//         }

//         const selectedCategory = categories.find(
//             category => category.dishName.trim().toLowerCase() === categoryName.trim().toLowerCase()
//         );

//         if (selectedCategory) {
//             // console.log(`Selected parentId: ${selectedCategory.dishId}`);
//             setParentId(selectedCategory.dishId);
//             setActiveCategory(categoryName);

//             // Display matching dishes
//             const matchingDishes = dishes.filter(
//                 dish => dish.parentId === selectedCategory.dishId
//             );
//             // console.log(`Dishes for parentId ${selectedCategory.dishId}:`, matchingDishes);
//         } else {
//             // console.log('Category not found');
//             setParentId(null);
//             setActiveCategory('Allitems');
//         }
//     };


//     const navigate = useNavigate();

//     // Automatically activate the first item from backend data
//     useEffect(() => {
//         if (categories.length > 0) {
//             setActiveCategory("Allitems"); // Default to "Allitems"
//         }
//     }, [categories]);



//     const currentCategoryItems = categories[activeCategory] || [];

//     const filteredItems = currentCategoryItems.filter((item) => {
//         if (isVegSelected) return item.type === "Veg";
//         if (isNonVegSelected) return item.type === "Non-veg";
//         return true;
//     });


//     const scrollContainerRef = useRef(null);




//     useEffect(() => {
//         const vendorId = localStorage.getItem("vendorId");

//         if (!vendorId) {
//             console.warn("⚠️ vendorId not found in localStorage");
//             return;
//         }
//         showLoader();
//         axios.get(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`)
//             .then((response) => {
//                 const allDishes = response.data;

//                 // Filter for dishes with the name "Combos"
//                 const combos = allDishes.filter(dish => dish.dishName === "Combos");

//                 // Find child dishes with matching parentId
//                 const filteredData = allDishes.filter(dish =>
//                     combos.some(combo => combo.dishId === dish.parentId)
//                 );

//                 setPosts(filteredData);
//             })
//             .catch((error) => {
//                 // console.error("Error fetching data:", error);
//             }).finally(() => {
//                 hideLoader();
//             })
//     }, []);





//     useEffect(() => {
//         const scrollContainer = scrollContainerRef.current;
//         if (!scrollContainer) return;

//         let interval;

//         const startScrolling = () => {
//             interval = setInterval(() => {
//                 if (!isHovered) {
//                     scrollContainer.scrollTop += 1; // Scroll down smoothly

//                     // Infinite loop logic
//                     if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
//                         scrollContainer.scrollTop = 0; // Reset to top for seamless loop
//                     }
//                 }
//             }, 20); // Adjust speed by changing interval
//         };

//         startScrolling();

//         return () => clearInterval(interval);
//     }, [isHovered]);


//     return (
//         <>
//             <div className="container-fluid">
//                 <div className="row " style={{ marginTop: "38px" }}>

//                     <div className="col-lg-2 col-md-3 col-sm-12 col-12"
//                         style={{ marginTop: window.innerWidth <= 767 ? "-30px" : " ", }}>

//                         <div
//                             style={{
//                                 maxHeight: "600px",
//                                 position: "sticky",
//                                 top: "0px",
//                                 marginTop: "67px",
//                                 zIndex: 1000,
//                                 // width: "180px",
//                                 scrollbarWidth: "none",
//                                 msOverflowStyle: "none",

//                             }}

//                             // className="menu-categroy-data"
//                             className="menu-side-scroll"
//                         >


//                             {isMobile ? (
//                                 <select
//                                     onChange={(e) => handleClick(e.target.value)}
//                                     value={activeCategory}
//                                     style={{
//                                         width: "100%",
//                                         padding: "10px",
//                                         borderRadius: "10px",
//                                         background: "rgb(177 93 198)",
//                                         color: "#fff",
//                                         fontWeight: "bold",
//                                         border: "1px solid #ccc",
//                                         marginBottom: "10px",
//                                         // Make sure the marginLeft isn't causing overflow or the dropdown to be hidden
//                                         marginLeft: "0px", // Temporarily remove margin for testing
//                                     }}
//                                 >
//                                     <option value="Allitems">All</option>
//                                     {categories.map((category) => (
//                                         <option key={category.dishId} value={category.dishName}>
//                                             {category.dishName}
//                                         </option>
//                                     ))}
//                                 </select>
//                             ) : (
//                                 // Card Layout for Desktop View
//                                 <div
//                                     style={{
//                                         overflowY: "auto",
//                                         height: window.innerHeight <= 700 ? "420px" : "550px",
//                                         marginTop: "96px",
//                                         scrollbarWidth: "none",
//                                         width: containerWidth,
//                                     }}
//                                 >

//                                     {/* "Allitems" Category Card */}
//                                     <div
//                                         className="card"
//                                         onClick={() => handleClick("Allitems")}
//                                         style={{
//                                             backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
//                                             marginTop: "4px",
//                                             padding: "0px",
//                                             display: "flex",
//                                             alignItems: "center",
//                                             flexDirection: "column",
//                                             cursor: "pointer",
//                                             zIndex: "1", // Corrected zIndex for proper click behavior
//                                         }}
//                                     >
//                                         <img
//                                             src={Tiffins}
//                                             className="card-img-top"
//                                             alt="Allitems"
//                                             style={{
//                                                 borderRadius: "50%",
//                                                 width: "100px",
//                                                 height: "100px",
//                                                 display: "block",
//                                                 margin: "5px auto 0",
//                                             }}
//                                         />
//                                         <br />
//                                         <div className="card-body d-flex justify-content-center p-0">
//                                             <button
//                                                 style={{
//                                                     borderRadius: "10px",
//                                                     marginTop: "-5px",
//                                                     fontSize: "14px",
//                                                     padding: "5px 10px",
//                                                     width: "100px",
//                                                     marginBottom: "5px",
//                                                     background: "#fff",
//                                                     color: "#000",
//                                                     fontWeight: "bold",
//                                                     border: "0px",
//                                                 }}
//                                             >
//                                                 All
//                                             </button>
//                                         </div>
//                                     </div>

//                                     {/* Dynamic Categories from API */}
//                                     {categories.map((category) => (
//                                         <div
//                                             key={category.dishId}
//                                             className="card"
//                                             onClick={() => handleClick(category.dishName)}
//                                             style={{
//                                                 backgroundColor: activeCategory === category.dishName ? "rgb(177 93 198)" : "#D9D9D9",
//                                                 marginTop: "10px",
//                                                 padding: "0px",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 flexDirection: "column",
//                                                 cursor: "pointer",
//                                                 height: "165px",
//                                             }}
//                                         >
//                                             <img
//                                                 className="card-img-top"
//                                                 src={category.dishImage}
//                                                 alt={category.dishName}
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100px",
//                                                     height: "98px",
//                                                     display: "block",
//                                                     margin: "5px auto 0",
//                                                     background: "#000",
//                                                     color: "#fff",
//                                                 }}
//                                             />
//                                             <br />
//                                             <div className="card-body d-flex justify-content-center p-0">
//                                                 <button
//                                                     style={{
//                                                         borderRadius: "10px",
//                                                         marginTop: "-5px",
//                                                         fontSize: "14px",
//                                                         padding: "5px 10px",
//                                                         background: "#fff",
//                                                         color: "#000",
//                                                         width: "100px",
//                                                         marginBottom: "5px",
//                                                         fontWeight: "bold",
//                                                         border: "0px",
//                                                     }}
//                                                 >
//                                                     {category.dishName}
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}

//                         </div>
//                     </div>

//                     <div className="col-lg-7 col-md-7 col-sm-12 col-12"
//                         style={{ marginTop: window.innerWidth > 500 && window.innerWidth <= 768 ? "-90px" : "20px", }}>
//                         <p
//                             className="breadcrumb maamaas-home-bredcum"
//                             style={{
//                                 position: "fixed",
//                                 top: window.innerWidth <= 425 ? " 60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
//                                 left: "2vw",
//                                 width: "100%",
//                                 backgroundColor: "#fff",
//                                 zIndex: window.innerWidth<=998 ? 1000 :  100000,
//                                 padding: "10px 0",
//                                 fontSize: isMobile ? "14px" : "18px",
//                                 fontWeight: isMobile ? "normal" : "bold",
//                                 textAlign: "center",
//                                 margin: 0,


//                             }}
//                         >
//                             {/* <Link
//                                 to="/Newmainlandingpage"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Home
//                             </Link>
//                             <span className="separator"> &gt; </span> */}
//                             <Link
//                                 to="/foodladingpage"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Food & Beverages
//                             </Link>
//                             <span className="separator"> &gt; </span>
//                             <Link
//                                 // to="/company"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Menu_Management
//                             </Link>
//                             <span className="separator"> &gt; </span>
//                             <Link
//                                 // to="/company"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Menu
//                             </Link>


//                         </p>
//                         <Menuiteams parentId={parentId} />
//                     </div>
//                     <div className="col-lg-3 col-md-3 col-sm-3 col-3">
//                         <MenuCartSidebar />
//                     </div>
//                 </div>


//             </div>
//         </>
//     );
// };

// export default Menudatas;









import React, { useState, useEffect, useRef } from "react";
import Tiffins from "../../../../images/products/all items.jpg";
import { Link } from "react-router-dom";
// import Offers from "./Offers";
import Menuiteams from "./Menuiteams";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Foodandbeveragesadvertise from "../../FoodandBeverages/Foodandbeveragesadvertise";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import MenuIcon from "@mui/icons-material/Menu";
import MenuCartSidebar from "./MenuCartSidebar.jsx";
const Menudatas = () => {
    const [activeCategory, setActiveCategory] = useState("");
    const [parentId, setParentId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [items, setItems] = useState([]); // Store API data
    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);  // Added state for dishes
    // const [parentId, setParentId] = useState(null);
    const [posts, setPosts] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    // NEW STATE: Control sidebar visibility for menu page
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);


    const [containerWidth, setContainerWidth] = useState(
        window.innerWidth > 1320 ? '160px' : window.innerWidth > 1000 ? '160px' : '150px'
    );

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1320) {
                setContainerWidth('170px');
            } else if (window.innerWidth > 1000) {
                setContainerWidth('150px'); // 👈 smaller width between 1000–1320px
            } else {
                setContainerWidth('150px');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            return;
        }

        if (!token) {
            console.warn("⚠️ authToken not found in localStorage");
            return;
        }
        showLoader();
        fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setItems(data); // Set all data without filtering
            })
            .catch((error) => console.error("Error fetching data:", error)).finally(() => {
                hideLoader();
            })
    }, []);

    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            return;
        }

        if (!token) {
            console.warn("⚠️ authToken not found in localStorage");
            return;
        }
        showLoader();
        fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                // Filter categories where parentId is 0 or null
                const filteredCategories = data.filter((item) => item.parentId === 0 || item.parentId === null);

                // Filter all dishes where parentId is not 0 or null
                const allDishes = data.filter((item) => item.parentId !== 0 && item.parentId !== null);

                // Set the filtered categories and dishes in state
                setCategories(filteredCategories);
                setDishes(allDishes);
            })
            .catch((error) => console.error("Error fetching data:", error)).finally(() => {
                hideLoader();
            })
    }, []);




    const handleClick = (categoryName) => {
        // console.log(`Clicked on category: ${categoryName}`);

        if (categoryName === 'Allitems') {
            setParentId(null);
            setActiveCategory('Allitems');
            // console.log('Selected parentId: null (All items selected)');
            return;
        }

        const selectedCategory = categories.find(
            category => category.dishName.trim().toLowerCase() === categoryName.trim().toLowerCase()
        );

        if (selectedCategory) {
            // console.log(`Selected parentId: ${selectedCategory.dishId}`);
            setParentId(selectedCategory.dishId);
            setActiveCategory(categoryName);

            // Display matching dishes
            const matchingDishes = dishes.filter(
                dish => dish.parentId === selectedCategory.dishId
            );
            // console.log(`Dishes for parentId ${selectedCategory.dishId}:`, matchingDishes);
        } else {
            // console.log('Category not found');
            setParentId(null);
            setActiveCategory('Allitems');
        }
    };


    const navigate = useNavigate();

    // Automatically activate the first item from backend data
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems"); // Default to "Allitems"
        }
    }, [categories]);



    const currentCategoryItems = categories[activeCategory] || [];

    const filteredItems = currentCategoryItems.filter((item) => {
        if (isVegSelected) return item.type === "Veg";
        if (isNonVegSelected) return item.type === "Non-veg";
        return true;
    });


    const scrollContainerRef = useRef(null);




    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            return;
        }
        showLoader();
        axios.get(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`)
            .then((response) => {
                const allDishes = response.data;

                // Filter for dishes with the name "Combos"
                const combos = allDishes.filter(dish => dish.dishName === "Combos");

                // Find child dishes with matching parentId
                const filteredData = allDishes.filter(dish =>
                    combos.some(combo => combo.dishId === dish.parentId)
                );

                setPosts(filteredData);
            })
            .catch((error) => {
                // console.error("Error fetching data:", error);
            }).finally(() => {
                hideLoader();
            })
    }, []);





    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        };

        startScrolling();

        return () => clearInterval(interval);
    }, [isHovered]);


    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "38px" }}>

                    <div className="col-lg-7 col-md-7 col-sm-12 col-12  maincontent"
                        style={{ marginTop: window.innerWidth > 500 && window.innerWidth <= 768 ? "-90px" : "20px" }}>

                        {/* Breadcrumb */}
                        <p className="breadcrumb maamaas-home-bredcum" style={{
                            position: "fixed",
                            top: window.innerWidth <= 425 ? "60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: window.innerWidth <= 998 ? 1000 : 100000,
                            padding: "10px 0",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}>

                            {/* <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span> */}
                            <Link
                                to="/fooddashboard"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                // to="/company"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Menu_Management
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                // to="/company"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Menu
                            </Link>
                        </p>

                        {/* Main Content Area */}
                        <div className="row"> {/* Add this row for proper alignment */}
                            {/* Categories Sidebar */}
                            <div className={`${isMobile ? 'col-12' : window.innerWidth>1500 ? 'col-lg-2' :'col-lg-3 col-md-3'} col-sm-12 col-12`}
                                style={{
                                    marginTop: window.innerWidth <= 767 ? "10px" : "0px",
                                    marginBottom: isMobile ? "20px" : "0px"
                                }}>

                                <div style={{
                                    maxHeight: "600px",
                                    position: isMobile ? "relative" : "sticky",
                                    top: isMobile ? "0px" : "100px",
                                    marginTop: isMobile ? "0px" : "67px",
                                    zIndex: 1000,
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                }} className="menu-side-scroll">

                                    {isMobile ? (
                                        <select
                                            onChange={(e) => handleClick(e.target.value)}
                                            value={activeCategory}
                                            style={{
                                                width: "100%",
                                                padding: "12px",
                                                borderRadius: "10px",
                                                background: "rgb(177 93 198)",
                                                color: "#fff",
                                                fontWeight: "bold",
                                                border: "1px solid #ccc",
                                                marginBottom: "10px",
                                                fontSize: "16px"
                                            }}
                                        >
                                            <option value="Allitems">All Items</option>
                                            {categories.map((category) => (
                                                <option key={category.dishId} value={category.dishName}>
                                                    {category.dishName}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <div style={{
                                            overflowY: "auto",
                                            height: window.innerHeight <= 700 ? "70vh" : "75vh",
                                            marginTop: "72px",
                                            scrollbarWidth: "none",
                                            width: "100%", // Use 100% instead of fixed width
                                            maxWidth: "150px" // Set max width for larger screens
                                        }}>
                                            {/* "Allitems" Category Card */}
                                            <div
                                                className="card"
                                                onClick={() => handleClick("Allitems")}
                                                style={{
                                                    backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
                                                    marginTop: "4px",
                                                    padding: "0px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    cursor: "pointer",
                                                    zIndex: "1",
                                                    width: "100%"
                                                }}
                                            >
                                                <img
                                                    src={Tiffins}
                                                    className="card-img-top"
                                                    alt="Allitems"
                                                    style={{
                                                        borderRadius: "50%",
                                                        width: "80px",
                                                        height: "80px",
                                                        display: "block",
                                                        margin: "5px auto 0",
                                                    }}
                                                />
                                                <div className="card-body d-flex justify-content-center p-0">
                                                    <button style={{
                                                        borderRadius: "10px",
                                                        marginTop: "5px",
                                                        fontSize: "14px",
                                                        padding: "5px 10px",
                                                        width: "100px",
                                                        marginBottom: "5px",
                                                        background: "#fff",
                                                        color: "#000",
                                                        fontWeight: "bold",
                                                        border: "0px",
                                                    }}>
                                                        All
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Dynamic Categories from API */}
                                            {categories.map((category) => (
                                                <div
                                                    key={category.dishId}
                                                    className="card"
                                                    onClick={() => handleClick(category.dishName)}
                                                    style={{
                                                        backgroundColor: activeCategory === category.dishName ? "rgb(177 93 198)" : "#D9D9D9",
                                                        marginTop: "10px",
                                                        padding: "0px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        cursor: "pointer",
                                                        height: "auto",
                                                        minHeight: "140px",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <img
                                                        className="card-img-top"
                                                        src={category.dishImage}
                                                        alt={category.dishName}
                                                        style={{
                                                            borderRadius: "50%",
                                                            width: "80px",
                                                            height: "80px",
                                                            display: "block",
                                                            margin: "5px auto 0",
                                                            background: "#000",
                                                            color: "#fff",
                                                            objectFit: "cover"
                                                        }}
                                                    />
                                                    <div className="card-body d-flex justify-content-center p-0">
                                                        <button style={{
                                                            borderRadius: "10px",
                                                            marginTop: "5px",
                                                            fontSize: "12px",
                                                            padding: "5px 8px",
                                                            background: "#fff",
                                                            color: "#000",
                                                            width: "100px",
                                                            marginBottom: "5px",
                                                            fontWeight: "bold",
                                                            border: "0px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}>
                                                            {category.dishName}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Menu Items */}
                            <div className={`${isMobile ? 'col-12' :window.innerWidth>1500 ? 'col-lg-10' : 'col-lg-9 col-md-9'} col-sm-12 col-12`}>
                                <Menuiteams parentId={parentId} />
                            </div>
                        </div>
                    </div>

                    {/* Cart Sidebar */}
                    <div className={`${isMobile ? 'col-12' : 'col-lg-3 col-md-3'} col-sm-12 col-12`} style={{ position: "fixed", right: "10px",display:window.innerWidth<=768 ? "none" : "block" }}>
                        <MenuCartSidebar />
                    </div>
                </div>
            </div>
            <style>
{`
    @media (min-width: 1000px) and (max-width: 1050px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 83%);
        }
    }

    @media (min-width: 1051px) and (max-width: 1100px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 84%);
        }
    }

    @media (min-width: 1101px) and (max-width: 1273px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 85%);
        }
    }
        
    @media (min-width: 1274px) {
        .maincontent {
            position: fixed;
            left: calc(100% - 86%);
        }
    }
`}
</style>
        </>
    );
};

export default Menudatas;
